export default [
  {
    title: 'Aluno',
    icon: 'UsersIcon',
    rule: 'students.menu',
    children: [
      {
        route: 'student-dashboard-index',
        title: 'Dashboard',
        icon: 'BarChart2Icon',
        rule: 'students.dashboard.menu'
      },
      {
        route: 'student-index',
        title: 'Gestão',
        icon: 'SettingsIcon',
        i18n: 'student.title',
        rule: 'students.show'
      }
    ]
  },
  {
    title: 'Professor',
    icon: 'UserCheckIcon',
    rule: 'teachers.menu',
    children: [
      {
        route: 'teacher-index',
        title: 'Gestão',
        icon: 'UserCheckIcon',
        i18n: 'teacher.title',
        rule: 'teachers.menu'
      },
      {
        route: 'teacher-my-lesson-index',
        title: 'Minhas Aulas',
        icon: 'ClockIcon',
        rule: 'teacher_my_lessons.grid'
      },
      {
        route: 'teacher-my-lesson-statistic-index',
        title: 'Estatísticas das Minhas Aulas',
        icon: 'BarChart2Icon',
        rule: 'teacher_my_lessons_statistic.grid'
      },
      {
        route: 'teacher-my-students-index',
        title: 'Meus Alunos',
        icon: 'UsersIcon',
        rule: 'teacher_my_students.menu'
      }
    ]
  },
  {
    route: 'modality-index',
    title: 'Modalidade',
    icon: 'AwardIcon',
    i18n: 'modality.title',
    rule: 'modalities.menu'
  },
  {
    route: 'establishment-index',
    title: 'Estabelecimento',
    icon: 'HomeIcon',
    i18n: 'establishment.title',
    rule: 'legal_entities.menu',
    // O profissional autônomo tem o próprio cadastro sob "Profissional" (cadastro guiado,
    // person_type=NE — ver router/routes/apps.js) e não deve enxergar "Estabelecimento"
    // (a tela de PJ/clube). Mesma permissão `legal_entities.menu` das duas, então quem separa
    // é hideForRoles, não a permissão — ver o mesmo caso para club_admin acima.
    //
    // `establishment` NÃO entra aqui: é justamente por este menu que o responsável
    // por um CNPJ chega ao próprio cadastro. O par com o `hideForRoles` de
    // "Profissional" acima é o que dá a cada papel uma porta só.
    hideForRoles: ['professional']
  },
  {
    title: 'Profissional',
    icon: 'UserCheckIcon',
    rule: 'legal_entities.menu',
    // Compartilha a permissão `legal_entities.menu` com "Estabelecimento" de propósito
    // (mesma tabela/CRUD — ver comentário em router/routes/apps.js), então não dá para
    // tirar o club_admin daqui só tirando permissão: sumiria também o próprio cadastro
    // do clube. hideForRoles resolve por papel, sem mexer na permissão.
    //
    // `establishment` (papel do auto-cadastro de parceiros, 2026-08-18) entra pela
    // mesma razão: quem responde por um CNPJ administra o cadastro dele em
    // "Estabelecimento" — estas telas são de pessoa física e a grid nem lista PJ
    // (o servidor força person_type=NE em /professionals/grid).
    hideForRoles: ['club_admin', 'establishment'],
    children: [
      {
        route: 'professional-index',
        title: 'Gestão',
        icon: 'SettingsIcon',
        rule: 'legal_entities.menu'
      },
      {
        // Vai direto para a própria ficha (aba "Repasse (Stripe)" incluída) — sem
        // isto o único caminho era passar pela grid de "Gestão" acima, pensada
        // para quem administra vários profissionais.
        route: 'professional-my-account',
        title: 'Meu Cadastro e Recebimento',
        icon: 'UserIcon',
        rule: 'legal_entities.edit'
      },
      {
        // Some para quem não é da Hubee: v-permission:any oculta o item quando a
        // permissão falta, e liberar alguém a vender é decisão da plataforma.
        route: 'professional-approvals',
        title: 'Aprovações',
        icon: 'CheckSquareIcon',
        rule: 'legal_entities.approve'
      }
    ]
  },
  {
    title: 'Aula',
    icon: 'DribbbleIcon',
    rule: 'lessons.menu',
    children: [
      {
        route: 'lesson-index',
        title: 'Gestão',
        icon: 'SettingsIcon',
        i18n: 'lesson.management',
        rule: 'lessons.menu'
      },
      {
        route: 'occupancy-index',
        title: 'Ocupação das turmas',
        icon: 'GridIcon',
        i18n: 'occupancy.menu',
        rule: 'legal_entities.occupancy'
      },
      {
        route: 'my-lesson-index',
        title: 'Minhas Aulas (aluno)',
        icon: 'DribbbleIcon',
        rule: 'my_lessons.grid'
      }
    ]
  },
  {
    title: 'Espaço de Locação',
    icon: 'HomeIcon',
    rule: 'rental_spaces.menu',
    children: [
      {
        route: 'rental-space-index',
        title: 'Gestão',
        icon: 'SettingsIcon',
        i18n: 'rental_space.management',
        rule: 'rental_spaces.menu'
      }
    ]
  },
  {
    title: 'Cancelamentos',
    icon: 'ShieldIcon',
    rule: 'cancellation_policies.menu',
    children: [
      {
        route: 'cancellation-policy-index',
        title: 'Políticas',
        icon: 'FileTextIcon',
        rule: 'cancellation_policies.show'
      },
      {
        route: 'cancellation-product-rules',
        title: 'Regras por Produto',
        icon: 'PackageIcon',
        rule: 'product_cancellation_rules.grid'
      },
      {
        route: 'cancellation-request-index',
        title: 'Solicitações',
        icon: 'InboxIcon',
        rule: 'cancellation_requests.grid'
      },
      {
        route: 'cancellation-movement-index',
        title: 'Fila de Reembolsos',
        icon: 'DollarSignIcon',
        rule: 'cancellation_movements.grid'
      },
      {
        route: 'cancellation-index-dashboard',
        title: 'Índice de Cancelamentos',
        icon: 'BarChart2Icon',
        rule: 'cancellation_index.show'
      }
    ]
  },
  {
    /*
     * Privacidade (LGPD). `privacy.menu` é o grupo pai — sem ele
     * `canViewVerticalNavMenuGroup` esconde o grupo inteiro, e os filhos junto,
     * mesmo concedidos. Só o papel `admin` recebe estas permissões.
     */
    title: 'Privacidade',
    icon: 'LockIcon',
    rule: 'privacy.menu',
    children: [
      {
        route: 'privacy-requests-index',
        title: 'Requisições de Titular',
        icon: 'InboxIcon',
        rule: 'privacy.requests.grid'
      },
      {
        route: 'privacy-consents-index',
        title: 'Consentimentos',
        icon: 'CheckSquareIcon',
        rule: 'privacy.consents.grid'
      },
      {
        route: 'privacy-access-logs-index',
        title: 'Log de Acesso',
        icon: 'EyeIcon',
        rule: 'privacy.access_log.grid'
      }
    ]
  },
  {
    title: 'Plano de Assinatura',
    icon: 'CreditCardIcon',
    rule: 'subscription_plans.menu',
    children: [
      {
        route: 'subscription-plan-index',
        title: 'Planos',
        icon: 'SettingsIcon',
        i18n: 'subscription_plan.management',
        rule: 'subscription_plans.menu'
      },
      {
        route: 'subscription-index',
        title: 'Assinaturas',
        icon: 'FileTextIcon',
        i18n: 'subscription.management',
        rule: 'subscriptions.menu'
      },
      {
        route: 'user-credit-cards-index',
        title: 'Cartões de usuários',
        icon: 'CreditCardIcon',
        i18n: 'user_credit_cards.menu',
        rule: 'subscriptions.menu'
      },
      {
        route: 'my-subscription-index',
        title: 'Meus Planos',
        icon: 'UserIcon',
        i18n: 'my_subscription.management',
        rule: 'my_subscriptions.menu'
      }
    ]
  },
  {
    // Grupo separado do de Divulgação: quem vê este é o influencer, e ele não
    // tem nenhuma permissão de campanhas.* nem influencers.*
    title: 'Meu Painel',
    icon: 'TrendingUpIcon',
    rule: 'influencer_panel.menu',
    children: [
      {
        route: 'influencer-panel-dashboard',
        title: 'Resumo',
        i18n: 'influencer_panel.menu_dashboard',
        rule: 'influencer_panel.menu'
      },
      {
        route: 'influencer-panel-campaigns',
        title: 'Minhas Campanhas',
        i18n: 'influencer_panel.menu_campaigns',
        rule: 'my_campaigns.menu'
      },
      {
        route: 'influencer-panel-wallet',
        title: 'Minha Carteira',
        i18n: 'influencer_panel.menu_wallet',
        rule: 'my_wallet.menu'
      }
    ]
  },
  {
    title: 'Divulgação',
    // O feather não tem megafone; Volume2 é o ícone de "divulgação" disponível.
    icon: 'Volume2Icon',
    // Gate no filho mais amplo, não no mais restrito: canViewVerticalNavMenuGroup
    // esconde o grupo inteiro quando falta a permissão do pai, e um clube que só
    // gerencia campanhas (sem acesso ao cadastro de influencers) perderia o menu
    // todo se isto fosse 'influencers.menu'.
    rule: 'campaigns.menu',
    children: [
      {
        route: 'campaign-index',
        title: 'Campanhas',
        i18n: 'campaign.menu',
        rule: 'campaigns.menu'
      },
      {
        route: 'campaign-approvals',
        title: 'Aceite de Campanhas',
        i18n: 'campaign.approvals',
        rule: 'campaigns.approve'
      },
      {
        route: 'influencer-index',
        title: 'Influencers',
        i18n: 'influencer.menu',
        rule: 'influencers.menu'
      },
      {
        route: 'influencer-approvals',
        title: 'Aprovações',
        i18n: 'influencer.approvals',
        rule: 'influencers.approve'
      },
      {
        route: 'influencer-group-index',
        title: 'Grupos',
        i18n: 'influencer_group.menu',
        rule: 'influencer_groups.menu'
      },
      {
        route: 'influencer-level-index',
        title: 'Níveis',
        i18n: 'influencer_level.menu',
        rule: 'influencer_levels.menu'
      }
    ]
  },
  {
    title: 'Produto',
    icon: 'ArchiveIcon',
    rule: 'products.menu',
    // Desde 2026-08-15 o produto é criado e publicado dentro do cadastro do
    // próprio item (aula/plano/espaço). Esta tela segue existindo para o admin
    // da plataforma — suporte, produtos legados com vários itens e o destaque
    // da Home — mas some para quem gerencia estabelecimento, senão viram duas
    // portas concorrentes para a mesma coisa.
    hideForRoles: ['club_admin', 'professional', 'establishment'],
    children: [
      {
        route: 'product-index',
        title: 'Configuração',
        icon: 'SettingsIcon',
        rule: 'products.grid'
      }
    ]
  },
  {
    title: 'Financeiro',
    icon: 'DollarSignIcon',
    rule: 'financial.menu',
    children: [
      {
        // Fila de trabalho do programa de influencers. Vem primeiro porque é a
        // unica tela do modulo que exige acao diaria de alguem.
        route: 'withdrawal-index',
        title: 'Fila de Saques',
        icon: 'SendIcon',
        i18n: 'withdrawal.menu',
        rule: 'withdrawals.menu'
      },
      {
        route: 'wallet-index',
        title: 'Carteiras',
        icon: 'CreditCardIcon',
        i18n: 'wallet_admin.menu',
        rule: 'wallets.menu'
      },
      {
        route: 'commission-index',
        title: 'Comissoes',
        icon: 'PercentIcon',
        i18n: 'commission.menu',
        rule: 'commissions.menu'
      },
      {
        route: 'wallet-settlement-index',
        title: 'Liquidacao com o Clube',
        icon: 'RepeatIcon',
        i18n: 'settlement.menu',
        rule: 'wallet_settlements.menu'
      },
      {
        route: 'financial-dashboard-index',
        title: 'financial.dashboard',
        icon: 'BarChart2Icon',
        // Separada de financial.dashboard.menu (2026-08-17): quem tem só o
        // Painel do Stripe abaixo não vê este item.
        rule: 'financial.dashboard_panel.menu'
      },
      {
        // Não é uma tela: a rota só busca o login link e redireciona a própria
        // aba para o Stripe. target: '_blank' é o que faz o clique abrir aba
        // nova em vez de navegar a atual para fora do Hubee. Permissão própria
        // (financial.stripe_dashboard.menu) para dar de sozinha a um papel
        // restrito ao Painel do Stripe (ex.: professional, club_admin).
        route: 'financial-stripe-dashboard-redirect',
        title: 'Painel do Stripe',
        icon: 'ExternalLinkIcon',
        target: '_blank',
        rule: 'financial.stripe_dashboard.menu'
      },
      {
        route: 'financial-orders-index',
        title: 'Pedidos',
        icon: 'ShoppingBagIcon',
        rule: 'financial.orders.menu'
      },
      {
        route: 'financial-product-revenue-index',
        title: 'Receitas por Produto',
        icon: 'PackageIcon',
        rule: 'financial.product-revenue.menu'
      },
      {
        route: 'financial-teacher-revenue-index',
        title: 'Receitas do Professor',
        icon: 'UserIcon',
        rule: 'financial.teacher-revenue.menu'
      },
      {
        route: 'financial-student-revenue-index',
        title: 'Receitas por Aluno',
        icon: 'UsersIcon',
        rule: 'financial.student-revenue.menu'
      },
      {
        route: 'financial-split-index',
        title: 'Split',
        icon: 'Share2Icon',
        rule: 'financial.split.menu'
      },
      {
        route: 'my-fees-index',
        title: 'Minhas Taxas',
        icon: 'InfoIcon',
        rule: 'financial.fees.show'
      },
      {
        route: 'financial-fees-index',
        title: 'Taxas da Plataforma',
        icon: 'PercentIcon',
        rule: 'financial.fees.menu'
      },
      {
        route: 'fee-plans-index',
        title: 'Planos de Cobrança',
        icon: 'LayersIcon',
        rule: 'fee_plans.menu'
      },
      {
        route: 'payment-gateway-settings',
        title: 'Gateway de Pagamento',
        icon: 'CreditCardIcon',
        i18n: 'payment_gateway.menu',
        rule: 'payment_gateway.menu'
      }
    ]
  },
  {
    route: 'ticket-validate',
    title: 'Validar Ingresso',
    icon: 'CheckSquareIcon',
    rule: 'tickets.menu'
  },
  {
    // Sem `rule`: o `v-permission` ignora item sem regra, e é o que se quer —
    // suporte vale para todo perfil, do admin ao influencer.
    //
    // A exceção é o validador de ingresso: como TODO o resto do menu é fechado
    // por permissão e ele só tem `tickets.*`, este item sem regra seria o único
    // sobrevivente ao lado do leitor — um menu de dois itens, um deles inútil
    // para quem está na portaria. `hideForRoles` só esconde de quem tem
    // exclusivamente esse papel, então quem acumula papéis continua vendo.
    route: 'support',
    title: 'Suporte',
    icon: 'LifeBuoyIcon',
    i18n: 'support.menu',
    hideForRoles: ['ticket_validator']
  },
  {
    title: 'Segurança',
    icon: 'ShieldIcon',
    rule: 'acl.menu',
    children: [
      {
        route: 'users',
        title: 'Users',
        icon: 'UserIcon',
        rule: 'users.menu'
      },
      {
        route: 'roles',
        title: 'Roles',
        icon: 'TargetIcon',
        rule: 'roles.menu'
      },
      {
        route: 'functionality-index',
        title: 'Functionalities',
        icon: 'GridIcon',
        rule: 'functionalities.menu'
      }
    ]
  }
]
